import { render } from "./D_commonQuestionList.vue?vue&type=template&id=b602b21e"
import script from "./D_commonQuestionList.vue?vue&type=script&lang=js"
export * from "./D_commonQuestionList.vue?vue&type=script&lang=js"

import "./D_commonQuestionList.vue?vue&type=style&index=0&id=b602b21e&lang=css"

import exportComponent from "C:\\Users\\SAEUM\\Desktop\\teampl-project\\github\\unibuzzy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__